import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 30px;
  top: 50%;
  width: 690px;
  max-height: 650px;
  background: #fff;
  z-index: 99999;
  border-radius: 18px;
  box-shadow: 4px 3px 4px 0 rgba(0, 0, 0, 0.25);

  overflow-y: auto;
  scrollbar-width: thin; /* Para Firefox */

  /* Estilização da barra de rolagem para Chrome/Safari */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 10px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .header h2,
  .header span {
    font-size: 20px;
    font-weight: 500;
  }

  input,
  textarea {
    width: 100%;
    border: 1px solid #9a9a9a;
    border-radius: 18px;
    padding: 0 5px;
  }

  input {
    height: 40px;
  }

  textarea {
    min-height: 80px;
    padding: 10px;
    font-family: inherit;
    resize: vertical;
  }

  label {
    margin-bottom: 10px;
    display: flex;
  }

  label:after {
    content: '*';
    display: block;
    margin: 0 5px;
    color: red;
  }

  label.optional:after {
    display: none;
  }

  @media (max-width: 960px) {
    width: 90%;
    margin: 0 auto;
    padding: 10px;
    top: 50%;
    max-height: 85vh;
    overflow-y: auto;
`;

export const FormRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  .NameField {
    display: flex;
    flex-direction: column;
    width: 45%;
  }
  .PlaceIDField {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .TitleHeader {
    display: flex;
    flex-direction: row;
  }

  @media (max-width: 960px) {
    flex-direction: column;

    .NameField {
      width: 100%;
      margin-bottom: 10px;
    }
  }
`;

export const LinksList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const LinkItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  input {
    flex: 1;
    min-width: 0;
  }
`;

const BaseActionButton = styled.button`
  height: 40px;
  border-radius: 18px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RemoveButton = styled(BaseActionButton)`
  padding: 0 10px;
  border: 1px solid #dc3545;
  color: #dc3545;

  &:hover {
    background: #dc3545;
    color: #fff;
  }
`;

export const AddButton = styled(BaseActionButton)`
  width: fit-content;
  padding: 0 15px;
  border: 1px solid #198754;
  color: #198754;

  &:hover {
    background: #198754;
    color: #fff;
  }
`;

export const ButtonsDiv = styled.div`
  display: flex;
  gap: 10px;
  justify-content: end;

  /* Nota: Corrigi a sintaxe do seletor de primeiro filho */
  & > button:first-child {
    background-color: #fff;
    color: #ffcb29;
    border: 0.5px solid #ffcb29;

    &:hover {
      background-color: #020c90;
      color: #fff;
      border: 0.5px solid #020c90;
    }
  }
`;

export const InputField = styled.div``;
export const SignUpForm = styled.div``;
